import { render } from "./TextReaderProducto.vue?vue&type=template&id=76b04ec6"
import script from "./TextReaderProducto.vue?vue&type=script&lang=js"
export * from "./TextReaderProducto.vue?vue&type=script&lang=js"

import "./TextReaderProducto.vue?vue&type=style&index=0&id=76b04ec6&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__